import { type Actions, ActionTypes } from './actions';
import { type Settings } from './model';

export type SettingsState = Settings;

const initialState = {
  pricingCalculator: false,
  enableHighUsageChart: false,
  enableOverages: false,
  recentlyViewedAccounts: false,
  removeServerConnections: false,
  enableMemberSessions: false,
  dataExportPercentagePricing: false,
  enablePaginationOfMembers: false,
  enableHoneycombLinks: false,
  displayImmediatelyActionableProductsInAccountProvisionReview: false,
  enableExtendingEnterpriseTrialCampaign: false,
  enableExtendingGuardianTrialCampaign: false,
  enableSubscriptionStateFiltering: false,
  enableCancelImmediatelyFunctionality: false,
  enableGeneralTab: false,
  enableProvisioningModeToggle: false,
  enableReactQueryDevtools: false,
  enableUsageChartsV2: false,
  enableSdkVersionUsageDetails: false,
  enableRoleAndTeamFilter: false,
  enableRolesAndTeamsTab: false,
  enablePowerUsersTab: false,
  enableVitalAuditLogEnhancedSearch: true,
  enableUpdatedRoleDiffs: false,
  enableSelfServeDeveloper2025PlanSelection: false,
  enableSelfServeFoundation2025PlanSelection: false,
  enablePlanTypeInSearch: false,
  enableRelatedIdAccountSearch: false,
  enableAuthMethodColumn: false,
  enableMemberMfaReset: false,
  enableVitalResourceCountLimits: false,
  vitalstatistixDataExportObservability: false,
  enabledAuditlogJsonExport: false,
  enableAuditLogActorDisplay: false,
  slackWebHookPlanChanges: '',
  relatedIdAccountSearchEnabled: false,
  isFetching: false,
  error: null,
};

// oxlint-disable-next-line typescript/default-param-last
export const reducer = (state: SettingsState = initialState as SettingsState, action: Actions) => {
  switch (action.type) {
    case ActionTypes.UPDATE_SETTINGS_PUBLIC:
      return {
        ...state,
        ...action.settings,
      };
    case ActionTypes.UPDATE_SETTINGS_PRIVATE:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case ActionTypes.UPDATE_SETTINGS_PRIVATE_FULFILLED:
      return {
        ...state,
        ...action.settings,
        relatedIdAccountSearchEnabled: action.settings.relatedIdAccountSearchEnabled === true,
        isFetching: false,
        error: null,
      };
    case ActionTypes.UPDATE_SETTINGS_PRIVATE_FAILED:
      return {
        ...state,
        relatedIdAccountSearchEnabled: false,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};
